<template>
    <div class="outright">
        <div class="match" v-bind:class="{ _live: info.isLive }">
            <OutrightMatchInfo
                v-bind:info="info"
                v-bind:marketPageType="MarketPage.Outright"
            />
            <div class="outright-marketGroup-content">
                <div
                    v-if="!outrights"
                    style=" height: 18.5rem; padding-top: 4rem;background: #fbfbfb;"
                >
                    <Spinner />
                </div>
                <template v-else-if="info.type === 'outright'">
                    <OutrightOdds
                        v-for="outright in outrights"
                        v-bind:key="`${outright.id}-${outright.isLive}`"
                        v-bind:oddsData="outright"
                        v-bind:outrightTournament="info"
                        v-bind:displaySection="displaySection"
                    />
                </template>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
    import { storeToRefs } from 'pinia';
    import type { PropType } from 'vue';
    import { defineComponent, onMounted, onUnmounted } from 'vue';
    import Spinner from '@/components/common/Spinner.vue';
    import OutrightOdds from '@/components/match/marketCard/OutrightOdds.vue';
    import OutrightMatchInfo from '@/components/match/matchInfo/OutrightMatchInfo.vue';
    import type { IOutrightTournament } from '@/interface/IOutright';
    import { DisplaySection, MarketPage } from '@/interface/enum';
    import { useOutrights } from '@/libraries/oddsApi/composables/useOutrights';
    import { useRootStore } from '@/stores/rootStore';

    export default defineComponent({
        name: 'Outright',
        components: {
            OutrightOdds,
            OutrightMatchInfo,
            Spinner,
        },
        props: {
            info: {
                type: Object as PropType<IOutrightTournament>,
                required: true,
            },
            displaySection: {
                type: Number as PropType<DisplaySection>,
                default: DisplaySection.Unknown,
            },
        },
        setup(props) {
            const { sportType } = storeToRefs(useRootStore());

            const { outrights, refetch } = useOutrights({
                leagueId: props.info.id,
                sportType,
                isLive: props.info.isLive,
                isEnabled: true,
            });

            function refreshMatch(outrightId: number, isCallApi: boolean, isLive: boolean) {
                if (outrightId === props.info.id
                    && isCallApi
                    && isLive === props.info.isLive) {
                    refetch();
                }
            }

            onMounted(() => {
                window.eventEmitter.on('refreshMatch', refreshMatch);
            });

            onUnmounted(() => {
                window.eventEmitter.off('refreshMatch', refreshMatch);
            });

            return {
                MarketPage,
                outrights,
            };
        },
    });
</script>

<style lang="scss" scoped>
@import "@/scss/components/sports/marketCard/outright";
</style>
